import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchBranchEmail } from '../../hooks/useInitialBranchEmail';
import Button from '../button/button';
import GeneralModal from '../modal/GeneralModal';
import VenueBranchDropdown from '../venueBranchDropdown/venueBranchDropdown';
import EditUniversalStaffLoginModal from './EditUniversalStaffLoginModal';
import ResetUniversalStaff from './ResetUniversalStaff';
import {
  UniversalStaffLoginModalType,
  ViewUniversalStaffLoginModalProps,
} from './type';

const ViewUniversalStaffLoginModal: React.FC<
  ViewUniversalStaffLoginModalProps
> = (props) => {
  const { t } = useTranslation();
  const { selectedBranch, email, isLoading, setSelectedBranch, refetch } =
    useFetchBranchEmail();
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showResetModal, setShowResetModal] = useState<boolean>(false);

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    refetch();
  };

  const handleCloseResetModal = () => {
    setShowResetModal(false);
    refetch();
  };

  return (
    <>
      <GeneralModal
        onClose={props?.onClose}
        headerTitle={t('universalStaffLoginModal.title')}
        headerTitleStyle="text-start font-inter leading-5"
        headerStyle="mt-4"
        body={
          <div className="flex flex-col w-full">
            <div className="text-black mb-6 max-w-2xl text-xs font-normal">
              {showEditModal
                ? t('universalStaffLoginModal.editDescription')
                : t('universalStaffLoginModal.description')}
            </div>
            <div className="space-y-4 mb-4">
              <div className="w-[50%] min-h-[2.5rem]">
                <VenueBranchDropdown
                  selectedBranch={selectedBranch}
                  onSelect={setSelectedBranch}
                  disabled={isLoading}
                />
              </div>
              <div className="flex w-full mt-4">
                <label className="w-[40%] text-black pt-3 text-xs font-helvetica font-[500] text-left">
                  {t('venueSetup.email')}
                </label>
                <div className="flex w-full items-center gap-2">
                  <label
                    className={`w-full font-helvetica text-xs font-[500] text-left flex-1 mt-3 ${
                      email ? 'text-black' : 'text-gray-500'
                    }`}
                  >
                    {isLoading
                      ? `...Fetching email for ${selectedBranch?.label}`
                      : email ||
                        t('universalStaffLoginModal.selectedVenueBranchError')}
                  </label>
                  {email ? (
                    <Button
                      className="px-6 py-3 rounded-full font-normal text-xs"
                      disabled={!selectedBranch?.value || !email || isLoading}
                      onClick={() => setShowEditModal(true)}
                    >
                      {t('universalStaffLoginModal.edit')}
                    </Button>
                  ) : (
                    !isLoading &&
                    selectedBranch?.value && (
                      <Button
                        className="px-6 py-3 rounded-full font-normal text-xs"
                        disabled={!selectedBranch?.value || isLoading}
                        onClick={() => setShowResetModal(true)}
                      >
                        {t('universalStaffLoginModal.add')}
                      </Button>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        }
      />

      {showEditModal && selectedBranch && (
        <EditUniversalStaffLoginModal
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
          onClose={handleCloseEditModal}
        />
      )}

      {showResetModal && selectedBranch && (
        <ResetUniversalStaff
          modalType={UniversalStaffLoginModalType.ADD}
          email=""
          onClose={handleCloseResetModal}
          selectedVenueBranch={selectedBranch}
          setSelectedVenueBranch={setSelectedBranch}
        />
      )}
    </>
  );
};

export default ViewUniversalStaffLoginModal;
